// Visual editor only: one section of a Custom page in the preview, with the
// name tab from the "Booking Page Visual Editor · Sections" design (3e, 3g,
// 3i). Hovering or tapping a section shows its tab (a tap has no hover to
// lean on, so the editor remembers the last section tapped). The tab is the
// only thing that selects the section, so clicking text inside still edits it
// inline.
//
// The public page never draws this: renderPageSections only wraps sections
// when the editor hands it a frame, so a live page's markup is unchanged.

const ListIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.75"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M8 6h13" />
    <path d="M8 12h13" />
    <path d="M8 18h13" />
    <path d="M3 6h.01" />
    <path d="M3 12h.01" />
    <path d="M3 18h.01" />
  </svg>
);

const GripIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    {[6, 12, 18].map((cy) => (
      <g key={cy} fill="currentColor">
        <circle cx="9" cy={cy} r="1.7" />
        <circle cx="15" cy={cy} r="1.7" />
      </g>
    ))}
  </svg>
);

const PageSectionFrame = ({
  section,
  title,
  selected,
  moving,
  peeked,
  onSelect,
  onPeek,
  children,
}) => {
  const name = title || "Section";
  const className = [
    "profile-section-frame",
    `profile-section-frame--${section.type}`,
    selected ? "is-selected" : "",
    moving ? "is-moving" : "",
    peeked ? "is-peek" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    // The click still reaches the page, which selects the style group under it.
    <div className={className} data-page-section={section.id} onClick={() => onPeek?.(section.id)}>
      <button
        type="button"
        className="profile-section-frame__tab"
        aria-label={`Find ${name} in Sections`}
        onClick={(event) => {
          // The page's own click handler would select a style group instead.
          event.stopPropagation();
          onSelect?.(section.id);
        }}
      >
        {moving ? <GripIcon /> : <ListIcon />}
        <span>{moving ? `Moving ${name}` : name}</span>
      </button>
      {children}
    </div>
  );
};

export default PageSectionFrame;
